import { gql } from '@apollo/client';

export const SEND_TRACKING_INFO = gql`
query trackingInfo($eventName: String!,$eventProperties: String!) {
    sendTrackingInfo(eventName:$eventName,eventProperties:$eventProperties )
  }`;
